import {SagaIterator} from 'redux-saga';
import {call} from 'redux-saga/effects';

import {AddressType} from 'desktop/types/addressType';
import {CustomerAddressType} from 'desktop/types/customerAddressesType';

import {getStatesForCountry} from '../getStatesForCountry/getStatesForCountry';

import {getPreparedAddresses} from './utils/getPreparedAddresses/getPreparedAddresses';

type DecomposedAddressesType = {
    shippingAddress: AddressType;
    billingAddress: AddressType;
};

/**
 * Perform "raw" address decomposition to useful address form
 * @param {CustomerAddressType} shippingAddress - Shipping address from store
 * @param {CustomerAddressType} billingAddress - Billing address from store
 * @param {boolean} addressesIsSame - Shipping and billing addresses sameness value from store
 * @returns {SagaIterator<DecomposedAddressesType>} - Decomposition result
 */
export function* decomposeAllAddressesByComponents(
    shippingAddress: CustomerAddressType,
    billingAddress: CustomerAddressType,
    addressesIsSame: boolean,
): SagaIterator<DecomposedAddressesType> {
    const shippingAddressStates = yield call(getStatesForCountry, shippingAddress.country);
    const billingAddressStates = yield call(getStatesForCountry, billingAddress.country);
    const states = [shippingAddressStates, billingAddressStates];

    if (addressesIsSame) {
        const [shipping] = yield call(getPreparedAddresses, [shippingAddress], states);
        return {billingAddress: shipping, shippingAddress: shipping};
    }
    const [shipping, billing] = yield call(
        getPreparedAddresses,
        [shippingAddress, billingAddress],
        states,
    );
    return {billingAddress: billing, shippingAddress: shipping};
}
